import fileDownload from "js-file-download";
import React, { useState } from "react";
import { useDataProvider, useNotify } from "react-admin";
import { StyledButton } from "../../../components/ListShowButton";

interface IDownloadMergedExcelButton {
  purchaseInvoiceSummaryId: number;
  period: string;
  disabled?: boolean;
}

const DownloadMergedExcelButton = ({
  purchaseInvoiceSummaryId,
  period,
  disabled = false,
}: IDownloadMergedExcelButton) => {
  const provider = useDataProvider();
  const notify = useNotify();
  const [isLoading, setLoading] = useState(false);

  const getExcelFile = () => {
    if (disabled || isLoading ) return; // prevent triggering if disabled / multiple clicks

    setLoading(true);
    
    provider
      .downloadFile(
        `subcontractorPurchaseInvoiceSummaries/${purchaseInvoiceSummaryId}/downloadMergedExcel`
      )
      .then(({ data }: any) => {
        if (data) {
          fileDownload(
            data,
            `merged-purchase-invoice-summary-${purchaseInvoiceSummaryId}-${period}.xlsx`
          );
        } else {
          notify("The Excel doesn't exist.", "warning");
        }
      })
      .catch((error: any) => {
        notify(`Error : ${error.message}`, "error");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <StyledButton 
      variant="outlined" 
      onClick={getExcelFile} 
      disabled={disabled || isLoading}
    >
      {isLoading ? "Downloading..." : `Download Merged Purchase Invoice`}
    </StyledButton>
  );
};

export default DownloadMergedExcelButton;
